/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyPermissionsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyPermissions. */
export class FamilyPermissions {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyPermissions.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Family APIs to get specified family sharing permission for the current user.
   * @summary Retrieves specified family sharing permission information for the current user.
   * @param familyPermissionType Possible values include: 'DevicesStatus', 'ITPManage', 'ITPRead',
   * 'CreditMonitoringRead', 'CreditMonitoringManage'
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyPermissionsGetFamilyPermissionResponse>
   */
  getFamilyPermission(familyPermissionType: Models.FamilyPermissionType, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyPermissionsGetFamilyPermissionResponse>;
  /**
   * @param familyPermissionType Possible values include: 'DevicesStatus', 'ITPManage', 'ITPRead',
   * 'CreditMonitoringRead', 'CreditMonitoringManage'
   * @param callback The callback
   */
  getFamilyPermission(familyPermissionType: Models.FamilyPermissionType, callback: coreHttp.ServiceCallback<Models.FamilyPermission>): void;
  /**
   * @param familyPermissionType Possible values include: 'DevicesStatus', 'ITPManage', 'ITPRead',
   * 'CreditMonitoringRead', 'CreditMonitoringManage'
   * @param options The optional parameters
   * @param callback The callback
   */
  getFamilyPermission(familyPermissionType: Models.FamilyPermissionType, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.FamilyPermission>): void;
  getFamilyPermission(familyPermissionType: Models.FamilyPermissionType, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.FamilyPermission>, callback?: coreHttp.ServiceCallback<Models.FamilyPermission>): Promise<Models.FamilyPermissionsGetFamilyPermissionResponse> {
    return this.client.sendOperationRequest(
      {
        familyPermissionType,
        options
      },
      getFamilyPermissionOperationSpec,
      callback) as Promise<Models.FamilyPermissionsGetFamilyPermissionResponse>;
  }

  /**
   * Calls Family APIs to get family sharing permissions for the current user.
   * @summary Retrieves family sharing permissions information for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyPermissionsGetFamilyPermissionsResponse>
   */
  getFamilyPermissions(options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyPermissionsGetFamilyPermissionsResponse>;
  /**
   * @param callback The callback
   */
  getFamilyPermissions(callback: coreHttp.ServiceCallback<Models.AllFamilyPermissions>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getFamilyPermissions(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.AllFamilyPermissions>): void;
  getFamilyPermissions(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.AllFamilyPermissions>, callback?: coreHttp.ServiceCallback<Models.AllFamilyPermissions>): Promise<Models.FamilyPermissionsGetFamilyPermissionsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getFamilyPermissionsOperationSpec,
      callback) as Promise<Models.FamilyPermissionsGetFamilyPermissionsResponse>;
  }

  /**
   * Calls Family APIs to update family sharing permissions for the current user.
   * @summary Updates family sharing permissions settings for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyPermissionsUpdateFamilyPermissionResponse>
   */
  updateFamilyPermission(options?: Models.FamilyPermissionsUpdateFamilyPermissionOptionalParams): Promise<Models.FamilyPermissionsUpdateFamilyPermissionResponse>;
  /**
   * @param callback The callback
   */
  updateFamilyPermission(callback: coreHttp.ServiceCallback<Models.FamilyPermission>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateFamilyPermission(options: Models.FamilyPermissionsUpdateFamilyPermissionOptionalParams, callback: coreHttp.ServiceCallback<Models.FamilyPermission>): void;
  updateFamilyPermission(options?: Models.FamilyPermissionsUpdateFamilyPermissionOptionalParams | coreHttp.ServiceCallback<Models.FamilyPermission>, callback?: coreHttp.ServiceCallback<Models.FamilyPermission>): Promise<Models.FamilyPermissionsUpdateFamilyPermissionResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      updateFamilyPermissionOperationSpec,
      callback) as Promise<Models.FamilyPermissionsUpdateFamilyPermissionResponse>;
  }

  /**
   * Calls Family APIs to get ITP family sharing permissions for the current user.
   * @summary Retrieves ITP family sharing permissions information for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyPermissionsGetItpFamilyPermissionsResponse>
   */
  getItpFamilyPermissions(options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyPermissionsGetItpFamilyPermissionsResponse>;
  /**
   * @param callback The callback
   */
  getItpFamilyPermissions(callback: coreHttp.ServiceCallback<Models.ITPFamilyPermissions>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getItpFamilyPermissions(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.ITPFamilyPermissions>): void;
  getItpFamilyPermissions(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.ITPFamilyPermissions>, callback?: coreHttp.ServiceCallback<Models.ITPFamilyPermissions>): Promise<Models.FamilyPermissionsGetItpFamilyPermissionsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getItpFamilyPermissionsOperationSpec,
      callback) as Promise<Models.FamilyPermissionsGetItpFamilyPermissionsResponse>;
  }

  /**
   * Calls Family APIs to update ITP family sharing permissions for the current user.
   * @summary Updates ITP family sharing permissions settings for the current user.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  updateItpFamilyPermission(options?: Models.FamilyPermissionsUpdateItpFamilyPermissionOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  updateItpFamilyPermission(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateItpFamilyPermission(options: Models.FamilyPermissionsUpdateItpFamilyPermissionOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  updateItpFamilyPermission(options?: Models.FamilyPermissionsUpdateItpFamilyPermissionOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      updateItpFamilyPermissionOperationSpec,
      callback);
  }

  /**
   * Calls Family APIs to get credit monitoring family sharing permissions for the current user.
   * @summary Retrieves credit monitoring family sharing permissions information for the current
   * user.
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyPermissionsGetCreditMonitoringFamilyPermissionsResponse>
   */
  getCreditMonitoringFamilyPermissions(options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyPermissionsGetCreditMonitoringFamilyPermissionsResponse>;
  /**
   * @param callback The callback
   */
  getCreditMonitoringFamilyPermissions(callback: coreHttp.ServiceCallback<Models.ITPFamilyPermissions>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getCreditMonitoringFamilyPermissions(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.ITPFamilyPermissions>): void;
  getCreditMonitoringFamilyPermissions(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.ITPFamilyPermissions>, callback?: coreHttp.ServiceCallback<Models.ITPFamilyPermissions>): Promise<Models.FamilyPermissionsGetCreditMonitoringFamilyPermissionsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getCreditMonitoringFamilyPermissionsOperationSpec,
      callback) as Promise<Models.FamilyPermissionsGetCreditMonitoringFamilyPermissionsResponse>;
  }

  /**
   * Calls Family APIs to update credit monitoring family sharing permissions for the current user.
   * @summary Updates credit monitoring family sharing permissions settings for the current user.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  updateCreditMonitoringFamilyPermission(options?: Models.FamilyPermissionsUpdateCreditMonitoringFamilyPermissionOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  updateCreditMonitoringFamilyPermission(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateCreditMonitoringFamilyPermission(options: Models.FamilyPermissionsUpdateCreditMonitoringFamilyPermissionOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  updateCreditMonitoringFamilyPermission(options?: Models.FamilyPermissionsUpdateCreditMonitoringFamilyPermissionOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      updateCreditMonitoringFamilyPermissionOperationSpec,
      callback);
  }

  /**
   * Calls Family APIs to get the Family Sharing permission of the current user.
   * @summary Retrieves the Family Sharing permission of the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyPermissionsGetFamilySharingPermissionsResponse>
   */
  getFamilySharingPermissions(options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyPermissionsGetFamilySharingPermissionsResponse>;
  /**
   * @param callback The callback
   */
  getFamilySharingPermissions(callback: coreHttp.ServiceCallback<Models.FamilySharingResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getFamilySharingPermissions(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.FamilySharingResponse>): void;
  getFamilySharingPermissions(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.FamilySharingResponse>, callback?: coreHttp.ServiceCallback<Models.FamilySharingResponse>): Promise<Models.FamilyPermissionsGetFamilySharingPermissionsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getFamilySharingPermissionsOperationSpec,
      callback) as Promise<Models.FamilyPermissionsGetFamilySharingPermissionsResponse>;
  }

  /**
   * calls Family APIs to Update the Family Sharing permission of the current user
   * @summary Update the Family Sharing permission of the current user
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyPermissionsUpdateFamilySharingPermissionsResponse>
   */
  updateFamilySharingPermissions(options?: Models.FamilyPermissionsUpdateFamilySharingPermissionsOptionalParams): Promise<Models.FamilyPermissionsUpdateFamilySharingPermissionsResponse>;
  /**
   * @param callback The callback
   */
  updateFamilySharingPermissions(callback: coreHttp.ServiceCallback<Models.FamilySharingResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateFamilySharingPermissions(options: Models.FamilyPermissionsUpdateFamilySharingPermissionsOptionalParams, callback: coreHttp.ServiceCallback<Models.FamilySharingResponse>): void;
  updateFamilySharingPermissions(options?: Models.FamilyPermissionsUpdateFamilySharingPermissionsOptionalParams | coreHttp.ServiceCallback<Models.FamilySharingResponse>, callback?: coreHttp.ServiceCallback<Models.FamilySharingResponse>): Promise<Models.FamilyPermissionsUpdateFamilySharingPermissionsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      updateFamilySharingPermissionsOperationSpec,
      callback) as Promise<Models.FamilyPermissionsUpdateFamilySharingPermissionsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getFamilyPermissionOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/permissions/{familyPermissionType}",
  urlParameters: [
    Parameters.familyPermissionType
  ],
  responses: {
    200: {
      bodyMapper: Mappers.FamilyPermission
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getFamilyPermissionsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/permissions",
  responses: {
    200: {
      bodyMapper: Mappers.AllFamilyPermissions
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateFamilyPermissionOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/family/permissions",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.FamilyPermissionUpdate
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.FamilyPermission
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getItpFamilyPermissionsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/permissions/itp",
  responses: {
    200: {
      bodyMapper: Mappers.ITPFamilyPermissions
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateItpFamilyPermissionOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/family/permissions/itp",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ITPFamilyPermissionUpdate
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getCreditMonitoringFamilyPermissionsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/permissions/credit",
  responses: {
    200: {
      bodyMapper: Mappers.ITPFamilyPermissions
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateCreditMonitoringFamilyPermissionOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/family/permissions/credit",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ITPFamilyPermissionUpdate
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getFamilySharingPermissionsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/permissions/sharing",
  responses: {
    200: {
      bodyMapper: Mappers.FamilySharingResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateFamilySharingPermissionsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/family/permissions/sharing",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.FamilySharingRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.FamilySharingResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
